export const ClaimTypes = {
  Role: 'https://4rdigital.com/roles',
  EntityType: '4rdigital.profile.user.entitytype',
};
